import {AxiosRequestConfig, AxiosResponse} from 'axios';
import AxiosService from '@/services/AxiosService';

export enum METHODS {
    get = 'get',
    post = 'post',
    put = 'put',
    patch = 'patch',
    delete = 'delete',
    head = 'head',
    options = 'options'
}

class RequestService {
    client = AxiosService;

    async request({...requestConfig}: AxiosRequestConfig): Promise<AxiosResponse | null> {
        try {
            const res = await this.client?.request({...requestConfig});
            if (res && res.status >= 200 && res.status <= 299) return res;
        } catch (e: unknown) {
            if (e instanceof Error && e?.message) {
                console.error('Request error:', e?.message);
            }
            throw e;
        }

        return null;
    }
}

export default RequestService;
